export default __webpack_public_path__ + "static/media/exclamation-triangle-solid.03d439fa.svg";